import { Component, Input, SimpleChanges } from '@angular/core';
import { TpmItemsProcessorService } from '../../../../services/tpm-items-processor.service';

@Component({
  selector: 'app-work-list-item-task-card',
  standalone: false,
  templateUrl: './work-list-item-task-card.component.html',
  styleUrl: './work-list-item-task-card.component.css',
})
export class WorkListItemTaskCardComponent {
  @Input() item: any;
  @Input() remainQuantity: number = 0;
  @Input() pickedQuantity: number = 0;
  @Input() orderType: string = 'any';
  @Input() qtyLable: string = 'Required Quantity';
  @Input() readyLable: string = 'Picked';
  @Input() remainLable: string = 'Remaining to Pick';
  @Input() showLocatoin: boolean = false;
  constructor(private tpmItemsProcessorService : TpmItemsProcessorService){}
  ngOnChanges(changes: SimpleChanges) {
    if (changes['item']) {
    }
  }
  getShortProductName(productName: string | null): string {
    return this.tpmItemsProcessorService.extractProductName(productName ?? '');
  }
}
